import { editLeadStatus, getLeadInfoByCallId } from '../services/ccs-api.service'

/* eslint-disable no-shadow */
const state = () => ({
  currentLeadInfo: {},
  currentCallId: {},
  callStatusSnackbars: [],
})

const getters = {
  getCurrentLeadInfo(state) {
    return state.currentLeadInfo
  },
}

const mutations = {
  setCurrentLeadInfo(state, data) {
    if (data && Object.keys(data).length) {
      state.currentLeadInfo = data
    } else {
      state.currentLeadInfo = {}
    }
  },
  setCurrentCallId(state, callId) {
    state.currentCallId = callId
  },
  addCallStatusSnack(state, callStatusSnack) {
    state.callStatusSnackbars = [...state.callStatusSnackbars, callStatusSnack]
  },
  removeCallStatusSnack(state, snackId) {
    state.callStatusSnackbars = state.callStatusSnackbars.filter((snack) => snack._id !== snackId)
  },
  clearSnackbars(state) {
    state.currentLeadInfo = {}
    state.currentCallId = {}
    state.callStatusSnackbars = []
  },
}

// actions
const actions = {
  async fetchCurrentLeadInfoByCallId(context, callId) {
    const leadInfo = await getLeadInfoByCallId(callId)
    context.commit('setCurrentLeadInfo', leadInfo)
  },
  setCurrentLeadInfo(context, info) {
    context.commit('setCurrentLeadInfo', info)
  },
  setCurrentCallId(context, callId) {
    context.commit('setCurrentCallId', callId)
  },
  async changeCurrentLeadInfo(context, data) {
    await editLeadStatus(data)
  },
  addCallStatusSnack(context) {
    const { currentLeadInfo, currentCallId } = context.state
    if (Object.keys(currentLeadInfo).length && Object.keys(currentCallId).length) {
      context.commit('addCallStatusSnack', { ...currentLeadInfo, callId: currentCallId })
    }
  },
  removeCallStatusSnack(context, snackId) {
    context.commit('removeCallStatusSnack', snackId)
  },
  clearSnackbars(context) {
    context.commit('clearSnackbars')
  },
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
}
